export default __webpack_public_path__ + "static/media/feather_edit.8e3c648f.svg";